import { render, staticRenderFns } from "./FixedPointMap.vue?vue&type=template&id=9b35a804&scoped=true&"
import script from "./FixedPointMap.vue?vue&type=script&lang=js&"
export * from "./FixedPointMap.vue?vue&type=script&lang=js&"
import style0 from "./FixedPointMap.vue?vue&type=style&index=0&id=9b35a804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b35a804",
  null
  
)

export default component.exports